import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../../store";
import "./refundReConfirmation.scss";
import { MODAL_TYPE, TICKET_FLOW_TYPES } from "../../../../../models/tickets";
import { TICKET_FLOW } from "../../../../../constants/ticket";
import { setModal, toggleTicketModal } from "../../../../../store/ticketBooking/action";
import { IMAGE_URL_CONFIG } from "../../../../../constants/url";
import { onImgError } from "../../../../../utils/helper";
import { updateSeatDelieryApi } from "../../../../../services/films";
import { toast } from "react-toastify";
import { ICheckRefund } from "../../../../../models/payment";
import { refundPayment } from "../../../../../services/payment";
interface INoOfSeatsProps {
    onCloseModal: () => void;
}

const RefundeReConfirmation: FC<INoOfSeatsProps> = ({ onCloseModal }) => {

    const {
        countryId,
        modalType,
        prevModal,
        refundDetails
    } = useSelector((state: RootState) => ({
        countryId: state.applicationReducer.countryId,
        modalType: state.ticketBookingReducer.modal.type,
        prevModal: state.ticketBookingReducer.modal?.prevModal,
        refundDetails: state.ticketBookingReducer.refundDetails
    }));

    const dispatch = useDispatch();
    const [errorMessage, setErrorMessage] = useState("");
    const [concessionDetails, setConcessionDetails] = useState([]);
    const [seats, setSeats] = useState([]);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [refundData, setRefundData] = useState<ICheckRefund | null>(null);
    const [refundedConcession, setRefundedConcession] = useState([]);

    useEffect(() => {
        if (refundDetails && refundDetails.saleId) {
            setConcessionDetails(refundDetails?.refundData?.concessionData.filter((v: any) => v.refundstatus !== 'refund')?.filter((v: any) => {
                return !refundDetails?.refundItems.concessionInput?.find((t: any) => v.Id == t.RowId)
            }).map((v: any) => ({ ...JSON.parse(v.Extra), Id: v.Id })));
            setRefundedConcession(refundDetails?.refundData?.concessionData.filter((v: any) => v.refundstatus === 'refund').filter((v: any) => {
                return refundDetails?.refundItems.concessionInput?.find((t: any) => v.Id == t.RowId)
            }).map((v: any) => JSON.parse(v.Extra)));
            setSeats(refundDetails?.refundData?.ticketData.filter((v: any) => v.refundstatus !== 'refund').filter((v: any) => {
                return !refundDetails?.refundItems.ticketInput?.find((t: any) => v.Id == t.RowId)
            }).map((v: any) => ({ SeatId: v.Seat_number })));
            setSelectedSeats(refundDetails?.refundData?.selectedSeats ? refundDetails?.refundData?.selectedSeats : []);
        }
    }, [refundDetails])

    const handleServiceChange = (item: any, value: string, i: number) => {

        if (!value) {
            item.isSelected = false;
        } else {
            if (value === 'Self Collection') {
                item.isSelected = false;
                item.deliveryInfo = [];
                item.Delivery = 'Self Collection'
            } else {
                item.Delivery = 'Seat Delivery'
                const selectedSeat: any = selectedSeats.find((seat: any) => seat.SeatId === value);
                if (selectedSeat) {
                    item.deliveryInfo = {
                        ...item.deliveryInfo,
                        AreaNumber: selectedSeat.AreaNumber,
                        ColumnIndex: selectedSeat.ColumnIndex,
                        RowId: selectedSeat.RowIndex,
                        RowIndex: selectedSeat.RowIndex,
                        SeatNumber: selectedSeat.SeatId,
                        DeliveryOption: 1
                    }

                    item.isSelected = true;
                } else {
                    item.deliveryInfo = {
                        ...item.deliveryInfo,
                        SeatNumber: value,
                        DeliveryOption: 1
                    }
                    item.isSelected = true;
                }
            }
        }

        const concessions: any = [...concessionDetails];
        concessions[i] = { ...item };
        setConcessionDetails(concessions);
    };

    const handleDeliveryChange = (item: any, value: any, i: number) => {
        item.deliveryInfo = {
            ...item.deliveryInfo,
            Comment: value
        }
        const concessions: any = [...concessionDetails];
        concessions[i] = { ...item };
        setConcessionDetails(concessions);
    };

    const onNext = async () => {
        setErrorMessage("");
        if (!concessionDetails.every((v: any) => v.isSelected || (!v.isSelected && !v.deliveryInfo?.DeliveryOption))) {
            setErrorMessage('Service type is not selected');
            return;
        }

        const { status, data } = (await refundPayment(refundDetails?.payload)) as any;
        if (
            status &&
            data &&
            data.data &&
            (data.data.message === "Approved" || data.data.message === "Refund initiated")
        ) {
            const payload = {
                countryId,
                saleId: refundDetails?.saleId,
                requestType: 'updateSeatDelivery',
                concession: concessionDetails,
                refundedConcession: refundedConcession,
                email: refundDetails?.refundData?.email
            };
            const { data } = await updateSeatDelieryApi(payload);
            if (data && data.statusCode === 200) {
                const modal =
                    TICKET_FLOW[TICKET_FLOW_TYPES.REFUND][MODAL_TYPE.REFUND_CONFIRMATION];
                dispatch(
                    setModal({
                        ...modal,
                        type: MODAL_TYPE.REFUND,
                    })
                );
            } else {
                dispatch(toggleTicketModal(false));
                toast.error("Error occured, please try later");
            }
        } else {
            toast.error("Error occured please try later");
        }
    };

    const onPrev = async () => {
        const ticketType: TICKET_FLOW_TYPES = modalType;
        const prev: MODAL_TYPE = prevModal;
        const modal = TICKET_FLOW[ticketType][prev];
        dispatch(
            setModal({
                ...modal,
                type: modalType,
            })
        );
    };

    return (
        <div className="refund-re-confirmation row">
            <div className="col-md-12 food-and-beverage">
                <div className="food-and-beverage">
                    <h5 className="title">
                        Please re-confirm the service for your food/beverage item(s) below.
                    </h5>

                    <div className="food-items">
                        {concessionDetails.map((item: any, index: number) => (
                            <div key={item.id} className="food-item">
                                <div className="food-top">
                                    <img src={refundDetails?.refundData?.vistacdn + item?.Item_id} alt={item?.Description} onError={onImgError} />
                                    <div className="food-details">
                                        <h6>{item?.Description}</h6>
                                        <span>{item?.modifier?.join(" ,")}</span>
                                    </div>
                                </div>
                                {/* Food & Beverage Service Dropdown */}
                                <span>Food & Beverage Service</span>
                                <select
                                    className="full-width-select"
                                    onChange={(e) => handleServiceChange(item, e.target.value, index)}
                                >     <option value=''>Select service type</option>
                                    {seats.length == 0 ? <option value={'Self Collection'}>
                                        Self collect from counter
                                    </option> :
                                        seats?.map((seat: any) => (
                                            <option key={seat.SeatId} value={seat.SeatId}>
                                                Deliver to <b>Seat</b> {seat.SeatId}
                                            </option>
                                        ))}
                                </select>

                                {/* Show Deliver At dropdown only if seat delivery is selected */}
                                {item.isSelected === true && (
                                    <>
                                        <span>Deliver At</span>
                                        <select className="full-width-select-deliver-at" value={item?.deliveryInfo?.Comment}
                                            onChange={(e) => handleDeliveryChange(item, e.target.value, index)}>
                                            {['First Half', 'Second Half'].map((option: any) => (
                                                <option key={option} value={option}>
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                    {errorMessage ? (
                        <div className="error_message">
                            <span>{errorMessage}</span>
                        </div>
                    ) : null}

                    <div className="actions">
                        <button
                            type="button"
                            className="btn gray_btn cancel"
                            onClick={onPrev}
                        >
                            <img src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'arrow_white_left.svg'} />
                            <span>BACK</span>
                        </button>
                        <button className="btn gray_btn confirm" onClick={onNext}> <img className="white-tick" src={IMAGE_URL_CONFIG.DEFAULT_IMAGE_PATH + 'tick_white_small.svg'} /> CONFIRM ALL</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundeReConfirmation;
